"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLogged = void 0;
function isLogged() {
    return ((document.cookie.includes('userToken=') &&
        !document.cookie.includes('userToken=catalogo-generico')) ||
        document.cookie.includes('userTokenCheckout=') ||
        document.cookie.includes('isLogged'));
}
exports.isLogged = isLogged;
